module.exports = __webpack_public_path__ + "media/blog/autor-profile-img-cf0b2cd5.png";